/**
 * Normalização de nomes para comparação (RN-036).
 *
 * Vive no domínio, e não na persistência, porque é **regra de negócio**: é ela que
 * decide se "Torre  Única" e "torre única" são a mesma torre. A construção da chave de
 * unicidade no banco usa exatamente esta função — uma só definição, para que a validação
 * do caso de uso e o índice do banco nunca discordem.
 *
 * `trim` + colapso de espaços internos + minúsculas. **Acentos são preservados** de
 * propósito: "Térreo" e "Terreo" continuam sendo nomes diferentes. Fundi-los
 * automaticamente esconderia um erro de digitação em vez de mostrá-lo — na importação de
 * cronograma (Fase 3) a semelhança vira aviso de possível duplicata, nunca fusão.
 */
export function normalizeName(value: string): string {
  return value.trim().replace(/\s+/g, ' ').toLocaleLowerCase('pt-BR');
}

/** Duas grafias designam a mesma coisa? */
export function sameName(a: string, b: string): boolean {
  return normalizeName(a) === normalizeName(b);
}

/**
 * Comparação para ordenação alfabética em português.
 * Usada apenas como desempate — a ordenação estrutural é por `level`/`position` (RN-005).
 */
export function compareNames(a: string, b: string): number {
  return a.localeCompare(b, 'pt-BR', { sensitivity: 'base' });
}
